import { useState, useEffect } from 'react';
import styled, { keyframes } from 'styled-components/macro';
import { ImagesAsComponent } from 'assets/images';
import { deviceMax } from 'utils/styles/breakpoints';
import { COLORS } from 'utils/styles/colors';
import { FLEX_CONTAINER } from 'utils/styles/flex';

export const ScrollToTopButton = () => {
  const [showScroll, setShowScroll] = useState(false);

  useEffect(() => {
    const checkScrollTop = () => {
      if (!showScroll && window.pageYOffset > 400) {
        setShowScroll(true);
      } else if (showScroll && window.pageYOffset <= 400) {
        setShowScroll(false);
      }
    };
    window.addEventListener('scroll', checkScrollTop);

    return () => {
      window.removeEventListener('keydown', checkScrollTop);
    };
  }, [showScroll]);

  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <ScrollToTopBtn className="scrollTop" onClick={scrollTop} isShow={showScroll}>
      <ImagesAsComponent.ScrollToTopArrow />
    </ScrollToTopBtn>
  );
};

const fadeIn = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

const ScrollToTopBtn = styled.button`
  ${FLEX_CONTAINER.FlexCenterRow}
  position: fixed;
  width: 65px;
  height: 65px;
  display: ${({ isShow }) => (isShow ? 'flex' : 'none')};
  bottom: 36px;
  right: 26px;
  z-index: 1000;
  animation: ${fadeIn} 0.3s;
  transition: opacity 0.4s;
  background: ${COLORS.mainColor};
  border-radius: 50%;
  cursor: pointer;
  svg {
    width: 24px;
    height: 24px;
  }
  @media ${deviceMax.tablet} {
    width: 45px;
    height: 45px;
    right: 40px;
  }

  @media ${deviceMax.mobileL} {
    left: 0;
    right: 0;
    margin: 0 auto;
  }
`;
